import React from 'react'
import { useHistory } from 'react-router-dom'
import BaseButton from '../../components/BasicComponent/BaseButton'
import FixedBottom from '../../components/BasicComponent/FixedBottom'
import LayoutPartner from '../../components/FeaturesComponent/layoutPartner'
import { PATH } from '../../constants/router'
import taxCdsSmartAssistantBanner from '../../assets/images/tax_cds_smart_assistant_banner.png'

import taxCdsLookupCccdIcon from '../../assets/icons/tax_cds_lookup_cccd_icon.png'
import taxCdsObligationIcon from '../../assets/icons/tax_cds_obligation_icon.png'
import taxCdsFinalizationMonthIcon from '../../assets/icons/tax_cds_finalization_month_icon.png'
import taxCdsReminderIcon from '../../assets/icons/tax_cds_reminder_icon.png'
import taxCdsRiskWarningIcon from '../../assets/icons/tax_cds_risk_warning_icon.png'
import taxCdsFinancialSupportIcon from '../../assets/icons/tax_cds_financial_support_icon.png'

import './index.scss'

const BENEFITS = [
  {
    icon: taxCdsLookupCccdIcon,
    text: 'Tra cứu thông tin thuế theo CCCD'
  },
  {
    icon: taxCdsObligationIcon,
    text: 'Tra cứu nghĩa vụ thuế'
  },
  {
    icon: taxCdsFinalizationMonthIcon,
    text: 'Tra cứu thông tin quyết toán theo tháng'
  },
  {
    icon: taxCdsReminderIcon,
    text: 'Nhắc quyết toán Thuế TNCN'
  },
  {
    icon: taxCdsRiskWarningIcon,
    text: 'Cảnh báo trễ hạn / rủi ro'
  },
  {
    icon: taxCdsFinancialSupportIcon,
    text: 'Gợi ý giải pháp và đơn vị tài chính hỗ trợ nộp thuế'
  }
]

export default function TaxCDSIntroduce() {
  const history = useHistory()

  const handleRegister = () => {
  // Chuyển thẳng sang trang mua gói
    history.push(PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_SERVICES)
  }
  return (
    <LayoutPartner headerTitle="Trợ lý thuế thông minh" blendHeaderWithBody={false}>

      <div className="tax-cds-introduce">
        <div className="tax-cds-introduce__content">
          <img
            className="tax-cds-introduce__banner"
            src={taxCdsSmartAssistantBanner}
            alt="Trợ lý thuế thông minh"
          />

          <h1 className="tax-cds-introduce__title">
            Đăng ký Trợ lý thuế thông minh
          </h1>

          <div className="tax-cds-introduce__benefits">
            {BENEFITS.map((item, index) => (
              <div className="tax-cds-introduce__benefit" key={index}>
                <img
                  className="tax-cds-introduce__benefit-icon"
                  src={item.icon}
                  alt=""
                />
                <span className="tax-cds-introduce__benefit-text">{item.text}</span>
              </div>
            ))}
          </div>
        </div>

        <FixedBottom elementPaddingBottom="LayoutPartner">
          <div className="tax-cds-introduce__bottom">
            <BaseButton onClick={handleRegister}>Đăng ký ngay</BaseButton>
          </div>
        </FixedBottom>
      </div>
    </LayoutPartner>
  )
}